/* ===== KUSHI PRODUCT PAGE JS ===== */
(function() {
  'use strict';

  var productDataEl = document.getElementById('kushi-product-json');
  if (!productDataEl) return;

  var productData = JSON.parse(productDataEl.textContent);
  var variants = productData.variants;
  var currentVariant = null;

  /* Do the variants actually differ in price? If not (e.g. apparel sizes all
     the same price), we leave the server-rendered price untouched so the
     currency converter app (Selo) can convert it without the JS overwriting it. */
  var priceVaries = variants.some(function (v) {
    return v.price !== variants[0].price || v.compare_at_price !== variants[0].compare_at_price;
  });

  function findVariantFromOptions() {
    var selected = {};
    document.querySelectorAll('.kushi-swatch-element.active').forEach(function(el) {
      var fieldset = el.closest('.kushi-form-input');
      if (fieldset) {
        var label = fieldset.querySelector('.kushi-form-label');
        if (label) {
          var optName = label.getAttribute('data-option-name');
          selected[optName] = el.getAttribute('data-value');
        }
      }
    });
    document.querySelectorAll('.kushi-variant-pill.active').forEach(function(el) {
      var fieldset = el.closest('.kushi-form-input');
      if (fieldset) {
        var label = fieldset.querySelector('.kushi-form-label');
        if (label) {
          var optName = label.getAttribute('data-option-name');
          selected[optName] = el.getAttribute('data-value');
        }
      }
    });
    return variants.find(function(v) {
      var match = true;
      productData.options.forEach(function(opt, i) {
        if (selected[opt] && v['option' + (i + 1)] !== selected[opt]) {
          match = false;
        }
      });
      return match;
    }) || null;
  }

  function formatMoney(cents) {
    return (window.kushiCurrencySymbol || '$') + (cents / 100).toFixed(2);
  }

  /* Tell the currency converter app (Selo / generic) to re-convert the .money
     elements after the theme rewrites prices via JS (variant change / load). */
  function notifyCurrencyApp() {
    try {
      var apps = [window.Selo, window.selo, window.Currency, window.CurrencyConverter];
      apps.forEach(function (a) {
        if (!a) return;
        ['convertAll', 'convert', 'reconvert', 'refresh', 'update', 'init'].forEach(function (fn) {
          if (typeof a[fn] === 'function') { try { a[fn](); } catch (e) {} }
        });
      });
      ['selo:refresh', 'selo:reconvert', 'currency:refresh', 'currency:update'].forEach(function (ev) {
        document.dispatchEvent(new CustomEvent(ev));
        window.dispatchEvent(new CustomEvent(ev));
      });
    } catch (e) {}
  }

  function updatePriceDisplay(variant) {
    var saleEl = document.getElementById('kushi-price-sale');
    var regularEl = document.getElementById('kushi-price-regular');
    var badgeEl = document.getElementById('kushi-price-badge');

    if (!variant) return;
    /* Skip rewriting the price when all variants share one price — keeps the
       currency-converted (Selo) price intact on the product page. */
    if (!priceVaries) return;

    if (saleEl) saleEl.textContent = formatMoney(variant.price);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (regularEl) {
        regularEl.textContent = formatMoney(variant.compare_at_price);
        regularEl.style.display = '';
      }
      if (badgeEl) {
        var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        badgeEl.textContent = '-' + pct + '%';
        badgeEl.style.display = '';
      }
    } else {
      if (regularEl) regularEl.style.display = 'none';
      if (badgeEl) badgeEl.style.display = 'none';
    }

    /* re-run the currency converter after we changed the price text */
    setTimeout(notifyCurrencyApp, 60);
  }

  function updateVariantId(variant) {
    var input = document.getElementById('kushi-variant-id');
    if (input && variant) input.value = variant.id;
  }

  function updateSKU(variant) {
    var skuEl = document.getElementById('kushi-sku-value');
    if (skuEl && variant) skuEl.textContent = variant.sku || '';
  }

  function updateStock(variant) {
    var stockEl = document.getElementById('kushi-stock-label');
    var barFill = document.getElementById('kushi-inventory-fill');
    var atcBtn = document.getElementById('kushi-btn-atc');
    if (!variant) return;

    if (!variant.available) {
      if (stockEl) stockEl.textContent = 'Out Of Stock';
      if (barFill) barFill.style.width = '0%';
      if (atcBtn) atcBtn.disabled = true;
      return;
    }

    if (atcBtn) atcBtn.disabled = false;
    var info = (window.kushiInventory && window.kushiInventory[variant.id]) || null;

    if (info && info.tracked && info.qty > 0) {
      if (stockEl) stockEl.textContent = 'Hurry! Only ' + info.qty + ' Items Left In Stock';
      var w = info.qty > 100 ? 100 : info.qty;
      if (barFill) barFill.style.width = w + '%';
    } else {
      if (stockEl) stockEl.textContent = 'In Stock';
      if (barFill) barFill.style.width = '100%';
    }
  }

  function updateURL(variant) {
    if (variant && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  function onVariantChange() {
    currentVariant = findVariantFromOptions();
    if (!currentVariant) return;
    updatePriceDisplay(currentVariant);
    updateVariantId(currentVariant);
    updateSKU(currentVariant);
    updateStock(currentVariant);
    updateURL(currentVariant);

    syncGalleryToVariant(currentVariant);
  }

  /* Sync the main gallery + thumbnails to the variant's image and scroll to it */
  function syncGalleryToVariant(variant) {
    if (!variant || !variant.featured_image) return;
    var mainImg = document.getElementById('kushi-main-image');
    var imgId = variant.featured_image.id;
    var thumbs = document.querySelectorAll('.kushi-thumbnail-slider__item');
    var matched = null;
    thumbs.forEach(function(t) {
      if (parseInt(t.getAttribute('data-image-id'), 10) === imgId) matched = t;
    });

    if (matched) {
      var full = matched.getAttribute('data-full');
      if (mainImg && full) {
        mainImg.src = full;
        mainImg.alt = variant.featured_image.alt || productData.title;
      }
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      matched.classList.add('active');
      matched.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    } else if (mainImg) {
      /* No matching thumbnail (variant image not in gallery) — swap main image directly */
      mainImg.src = variant.featured_image.src;
      mainImg.alt = variant.featured_image.alt || productData.title;
    }
  }

  /* Image gallery */
  window.kushiChangeImage = function(thumb, src) {
    var mainImg = document.getElementById('kushi-main-image');
    if (mainImg) mainImg.src = src;
    document.querySelectorAll('.kushi-thumbnail-slider__item').forEach(function(t) {
      t.classList.remove('active');
    });
    thumb.classList.add('active');
  };

  /* Prev/next arrows on the main image */
  window.kushiSlide = function(dir) {
    var items = Array.prototype.slice.call(document.querySelectorAll('.kushi-thumbnail-slider__item'));
    if (!items.length) return;
    var idx = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].classList.contains('active')) { idx = i; break; }
    }
    idx = (idx + dir + items.length) % items.length;
    var next = items[idx];
    var src = next.getAttribute('data-full');
    if (src) kushiChangeImage(next, src);
    try { next.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); } catch (e) {}
  };

  /* Mobile sticky Add to Cart — mirror price + button state from the main controls */
  (function () {
    var priceSrc = document.getElementById('kushi-price-sale');
    var priceDst = document.getElementById('kushi-sticky-price');
    if (priceSrc && priceDst) {
      var syncPrice = function () { priceDst.textContent = priceSrc.textContent; };
      syncPrice();
      new MutationObserver(syncPrice).observe(priceSrc, { childList: true, characterData: true, subtree: true });
    }
    var btnSrc = document.getElementById('kushi-btn-atc');
    var btnDst = document.getElementById('kushi-sticky-btn');
    if (btnSrc && btnDst) {
      var syncBtn = function () {
        btnDst.disabled = btnSrc.disabled;
        btnDst.textContent = (btnSrc.textContent || '').trim();
      };
      syncBtn();
      new MutationObserver(syncBtn).observe(btnSrc, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
    }
  })();

  /* Color swatches */
  window.kushiActivateSwatch = function(el) {
    el.closest('.kushi-swatch-group').querySelectorAll('.kushi-swatch-element').forEach(function(s) {
      s.classList.remove('active');
    });
    el.classList.add('active');
    var colorName = el.getAttribute('data-value');
    var label = el.closest('.kushi-form-input').querySelector('.kushi-form-label span');
    if (label) label.textContent = colorName;
    onVariantChange();
  };

  /* Size pills */
  window.kushiActivatePill = function(el) {
    if (el.classList.contains('disabled')) return;
    el.closest('.kushi-variant-pills').querySelectorAll('.kushi-variant-pill').forEach(function(p) {
      p.classList.remove('active');
    });
    el.classList.add('active');
    var label = el.closest('.kushi-form-input').querySelector('.kushi-form-label span');
    if (label) label.textContent = el.getAttribute('data-value');
    onVariantChange();
  };

  /* Size chart modal */
  window.kushiOpenSizeChart = function() {
    var m = document.getElementById('kushi-size-chart-modal');
    if (m) { m.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  };
  window.kushiCloseSizeChart = function() {
    var m = document.getElementById('kushi-size-chart-modal');
    if (m) { m.classList.remove('is-open'); document.body.style.overflow = ''; }
  };
  (function() {
    var m = document.getElementById('kushi-size-chart-modal');
    if (!m) return;
    m.addEventListener('click', function(e) { if (e.target === m) window.kushiCloseSizeChart(); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && m.classList.contains('is-open')) window.kushiCloseSizeChart();
    });
  })();

  /* Quantity */
  window.kushiChangeQty = function(delta) {
    var input = document.getElementById('kushi-qty-input');
    if (!input) return;
    var val = parseInt(input.value) + delta;
    if (val < 1) val = 1;
    input.value = val;
  };

  /* Tabs */
  window.kushiSwitchTab = function(tabId, btn) {
    document.querySelectorAll('.kushi-tabs__panel').forEach(function(p) {
      p.classList.remove('active');
    });
    document.querySelectorAll('.kushi-tabs__btn').forEach(function(b) {
      b.classList.remove('active');
    });
    var panel = document.getElementById('kushi-tab-' + tabId);
    if (panel) panel.classList.add('active');
    btn.classList.add('active');
  };

  /* AJAX Add to Cart */
  window.kushiAddToCart = function() {
    var variantInput = document.getElementById('kushi-variant-id');
    var qtyInput = document.getElementById('kushi-qty-input');
    var btn = document.getElementById('kushi-btn-atc');
    if (!variantInput || !btn || btn.disabled) return;

    var variantId = parseInt(variantInput.value, 10);
    if (!variantId) {
      btn.textContent = 'Select options';
      setTimeout(function () { btn.textContent = btn.dataset.kushiLabel || 'Add to Cart'; }, 2000);
      return;
    }

    var originalText = btn.textContent;
    btn.dataset.kushiLabel = originalText;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    var drawer = document.querySelector('cart-drawer');
    var body = {
      id: variantId,
      quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1
    };

    /* Ask Shopify to also render the cart drawer + cart bubble so they update */
    var sectionIds = [];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try { drawer.getSectionsToRender().forEach(function (s) { sectionIds.push(s.id); }); } catch (e) {}
    }
    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: JSON.stringify(body)
    })
    .then(function(res) { return res.json(); })
    .then(function(res) {
      if (res.status) { /* error response (e.g. sold out / 422) */
        btn.textContent = res.description ? 'Unavailable' : 'Error - Try Again';
        setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 2000);
        return;
      }

      btn.textContent = 'Added!';
      setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 2000);

      if (drawer && res.sections && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(res); /* updates drawer + bubble and opens the drawer */
      } else {
        /* No drawer on the page → go to the cart so the user sees the item */
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: res }));
        window.location.href = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
      }
    })
    .catch(function() {
      btn.textContent = 'Error - Try Again';
      setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 2000);
    });
  };

  /* Recently Viewed */
  (function() {
    var KEY = 'kushi_recently_viewed';
    var MAX = 8;
    var grid = document.getElementById('kushi-recently-viewed-grid');
    var section = document.getElementById('kushi-recently-viewed-section');
    if (!grid || !section) return;

    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e) {}

    var isAvailable = productData.available;
    var isNew = (productData.tags || []).some(function (t) { return (t || '').toLowerCase() === 'new'; });
    var hasOnlyDefaultVariant = (productData.variants || []).length <= 1;
    var firstAvailableVariant = (productData.variants || []).filter(function (v) { return v.available; })[0] || (productData.variants || [])[0];

    var current = {
      handle: productData.handle,
      title: productData.title,
      url: productData.url,
      price: productData.price,
      compare_at_price: productData.compare_at_price,
      image: productData.featured_image,
      available: isAvailable,
      is_new: isNew,
      has_only_default_variant: hasOnlyDefaultVariant,
      variant_id: firstAvailableVariant ? firstAvailableVariant.id : null
    };

    list = list.filter(function(p) { return p.handle !== current.handle; });
    list.unshift(current);
    list = list.slice(0, MAX);
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch(e) {}

    var others = list.filter(function(p) { return p.handle !== current.handle; });
    if (others.length < 1) return;

    function esc(s) { return (s || '').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

    /* Same DOM structure/classes as snippets/kc-product-card.liquid, so it's
       styled identically by collection-page.css and works with the shared
       swatch/ATC script + the currency converter's .kc-card__price selector. */
    others.slice(0, 4).forEach(function(p) {
      var title = esc(p.title);
      var priceHtml;
      if (p.compare_at_price && p.compare_at_price > p.price) {
        var rvPct = Math.round((1 - p.price / p.compare_at_price) * 100);
        priceHtml = '<span class="kc-on-sale">' + formatMoney(p.price) + '</span> <s>' + formatMoney(p.compare_at_price) + '</s> <span class="kc-card__disc">-' + rvPct + '%</span>';
      } else {
        priceHtml = formatMoney(p.price);
      }

      var actionsHtml = '<a class="kc-card__action" href="' + p.url + '" title="View product" aria-label="View ' + title + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M1.5 12S5 5 12 5s10.5 7 10.5 7-3.5 7-10.5 7S1.5 12 1.5 12z"/><circle cx="12" cy="12" r="3"/></svg></a>';
      if (p.available) {
        if (p.has_only_default_variant && p.variant_id) {
          actionsHtml += '<button type="button" class="kc-card__action kc-card__atc" data-variant="' + p.variant_id + '" title="Add to cart" aria-label="Add ' + title + ' to cart">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg></button>';
        } else {
          actionsHtml += '<a class="kc-card__action" href="' + p.url + '" title="Choose options" aria-label="Choose options for ' + title + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg></a>';
        }
      }

      var card = document.createElement('div');
      card.className = 'kc-card';
      card.innerHTML =
        '<div class="kc-card__media">' +
        '<a href="' + p.url + '" class="kc-card__media-link" aria-label="' + title + '">' +
        (p.image ? '<img class="kc-card__img" data-default="' + p.image + '" src="' + p.image + '" alt="' + title + '" loading="lazy">' : '') +
        '</a>' +
        (p.is_new ? '<span class="kc-badge kc-badge--new">New</span>' : '') +
        (p.available ? '' : '<span class="kc-badge kc-badge--sold">Sold Out</span>') +
        '<div class="kc-card__actions">' + actionsHtml + '</div>' +
        '</div>' +
        '<div class="kc-card__info">' +
        '<a href="' + p.url + '" class="kc-card__title">' + title + '</a>' +
        '<div class="kc-card__price">' + priceHtml + '</div>' +
        '</div>';
      grid.appendChild(card);
    });

    section.style.display = '';
  })();

  onVariantChange();
})();
